import { call, put } from "redux-saga/effects";
import { getMeetingSlot, selectMeetingSlot } from "../../../../Services/apiService";
import { getSlotSuccess, getSlotFailure, selectDateTimeSuccess, selectDateTimeFailure } from "../../../Slices/slotSlice";

export function* fetchSlotHandler(actions) {
    try {
        let response = yield call(getMeetingSlot, actions?.payload);
        yield put(getSlotSuccess(response?.data));
    } catch (error) {
        yield put(getSlotFailure(error?.response?.data || 'Slot Choose Failed.'));
    }
}

export function* scheduleMeetingHandler(actions) {
    try {
        let response = yield call(selectMeetingSlot, actions?.payload);
        yield put(selectDateTimeSuccess(response?.data));
    } catch (error) {
        yield put(selectDateTimeFailure(error?.response?.data || 'Time Choosen Failed.'));
    }
}